import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  Flex,
  Badge,
  VStack,
  Spinner,
  Divider,
  Heading
} from '@chakra-ui/react';

interface Licencia {
  Estatus: string;
  Movimiento: string;
  montoLicencia: number;
  montoResiduos: number;
}

const DashboardLicencias = () => {
  const [licencias, setLicencias] = useState<Licencia[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://totolac-backend.togui.com.mx/api/licencias-comercio')
      .then((res) => res.json())
      .then((data) => {
        setLicencias(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error cargando licencias:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <Flex justify="center" align="center" h="300px">
        <Spinner size="xl" color="red.500" />
      </Flex>
    );
  }

  const total = licencias.length;
  const porEstatus = agruparPor(licencias, 'Estatus');
  const porMovimiento = agruparPor(licencias, 'Movimiento');
const totalLicencias = licencias.reduce(
  (sum, l) => sum + parseFloat(String(l.montoLicencia || 0)),
  0
);
const totalResiduos = licencias.reduce(
  (sum, l) => sum + parseFloat(String(l.montoResiduos || 0)),
  0
);

  const cumplimiento = Math.round(((porEstatus['Apertura'] || 0) / total) * 100);

  function agruparPor(arr: Licencia[], campo: keyof Licencia) {
    return arr.reduce((acc: Record<string, number>, item) => {
      let clave = item[campo] || 'Sin clasificar';
      
      if (campo === 'Movimiento' && typeof clave === 'string') {
        clave = clave.split(':')[0];
      }
      
      acc[clave] = (acc[clave] || 0) + 1;
      return acc;
    }, {});
  }

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>Resumen General</Heading>

      <SimpleGrid columns={{ base: 2, md: 4 }} spacing={4} mb={6}>
        <Stat>
          <StatLabel>Total de Licencias</StatLabel>
          <StatNumber>{total}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Ingresos Licencias</StatLabel>
          <StatNumber>${totalLicencias.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Ingresos Residuos</StatLabel>
          <StatNumber>${totalResiduos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel>Cumplimiento (Apertura)</StatLabel>
          <StatNumber>{cumplimiento}%</StatNumber>
        </Stat>
      </SimpleGrid>

      <Divider my={6} />

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        <Box>
          <Heading size="sm" mb={3}>Por Estatus</Heading>
          <VStack align="start" spacing={2}>
            {Object.entries(porEstatus).map(([estatus, count]) => (
              <Flex key={estatus} justify="space-between" w="100%">
                <Text>{estatus}</Text>
                <Badge colorScheme="green">{count}</Badge>
              </Flex>
            ))}
          </VStack>
        </Box>

          <Box>
            <Heading size="sm" mb={3}>Por Movimiento</Heading>
            <VStack align="start" spacing={2}>
              {Object.entries(porMovimiento).map(([mov, count]) => (
                <Flex key={mov} justify="space-between" w="100%">
                  <Text>{mov}</Text>
                  <Badge colorScheme="blue">{count}</Badge>
                </Flex>
              ))}
            </VStack>
          </Box>

      </SimpleGrid>
    </Box>
  );
};

export default DashboardLicencias;
